import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import App from 'modules/App';
import Account from 'modules/Account';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
const Actions = ()=>{
    const formValues = useSelector(App.selectors.formSelector(constants.REMOVE_PATIENT_FORM));
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const patient = get(formValues, 'contextData');
    const isInProgress = useSelector(selectors.isRemovePatientInProgress);
    const closeModal = useAction(App.actions.closeModal);
    const clearForm = useAction(App.actions.clearForm(constants.REMOVE_PATIENT_FORM));
    const onRemovePatient = useAction(actions.removePatient, patient, activeClinicMembership);
    const onClose = ()=>{
        closeModal();
        clearForm();
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "modal__actions row",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "quaternary",
                    labelMessage: messages.buttons.decline,
                    className: "btn--block",
                    isDisabled: isInProgress,
                    onClick: onClose
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "secondary",
                    labelMessage: messages.buttons.removePatient,
                    className: "btn--block btn--filled",
                    isInProgress: isInProgress,
                    onClick: onRemovePatient
                })
            })
        ]
    });
};
export default Actions;
